import { BaseTodoPlannerModel } from './base-todo-planner.model';

export class WeekTodoPlannerModel extends BaseTodoPlannerModel {}
